import { render, staticRenderFns } from "./exchangeLog.vue?vue&type=template&id=c01d45dc&scoped=true&"
import script from "./exchangeLog.vue?vue&type=script&lang=js&"
export * from "./exchangeLog.vue?vue&type=script&lang=js&"
import style0 from "./exchangeLog.vue?vue&type=style&index=0&id=c01d45dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d45dc",
  null
  
)

export default component.exports